import { render, staticRenderFns } from "./DisposedItemModal.vue?vue&type=template&id=47773c7c&scoped=true&"
import script from "./DisposedItemModal.vue?vue&type=script&lang=js&"
export * from "./DisposedItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47773c7c",
  null
  
)

export default component.exports